export const SOCKET_ADMIN_CANDIDATES = 'admin-candidates';
export const SOCKET_ADMIN_REMOVE_CANDIDATES = 'admin-candidates-not-pending';
export const SOCKET_ADMIN_REQUESTS = 'admin-requests';
export const SOCKET_ADMIN_REMOVE_REQUESTS = 'admin-requests-closed';
export const SOCKET_CANDIDATE_REQUEST_STATUS_CHANGE = 'candidate-request-status-change';
export const SOCKET_ADMIN_SCHOOLS = 'admin-schools';